const translations = {
  es: {
    nav: {
      portfolio: 'Portfolio',
      proceso: 'Proceso',
      testimonios: 'Testimonios',
      contacto: 'Contacto',
      hablemos: 'Hablemos',
      langLabel: 'ES',
    },
    hero: {
      titleLine1: 'HISTORIAS QUE',
      titleHighlight: 'VENDEN.',
      subtitle: 'Soy filmmaker y estratega de contenido. Produzco, dirijo y edito videos diseñados para posicionar tu marca, retener audiencias y convertir seguidores en clientes.',
      viewProjects: 'Ver Proyectos',
      contact: 'Contactar',
      statVisits: 'Visitas Generadas',
      statClients: 'Clientes Satisfechos',
      statRating: 'Rating Cliente',
      scrollCue: 'Sigue bajando',
    },
    clients: {
      badge: 'Confían en mí',
      title: 'Marcas que he transformado',
      description: 'Trabajo con marcas y creadores que entienden el contenido como un activo estratégico, no como una obligación diaria.',
      statVisits: 'Visitas generadas',
      statClients: 'Clientes satisfechos',
      statRating: 'Rating promedio',
    },
    portfolio: {
      badge: 'Portafolio',
      title: 'Videos y resultados reales',
      viewYoutube: 'Ver todo en YouTube',
      resultLabel: 'Resultado',
      category: 'Cliente',
      items: {
        joaquin_result: 'Proyectos destacados',
        joaquin_summary: 'Reels y contenidos para redes',
        edt_result: 'Campañas institucionales',
        edt_summary: 'Reels optimizados para conversión',
        indawork_result: 'Contenidos B2B',
        indawork_summary: 'Reels para posicionamiento',
        luma_result: 'Producción premium',
        luma_summary: 'Reels con acabado cinematográfico',
        rolitornillos_result: 'Contenido técnico',
        rolitornillos_summary: 'Reels demostrativos y promocionales',
        kukymotos_result: 'Campañas para ecom',
        kukymotos_summary: 'Reels orientados a venta',
        otros_result: 'Colección de reels',
        otros_summary: 'Proyectos adicionales',
        otros_title: 'Otros Proyectos Destacados',
      },
    },
    process: {
      badge: 'Mi Proceso',
      title: 'Cómo trabajo',
      description: 'Cada proyecto parte de entender tu marca desde adentro para construir un sistema que atraiga, eduque y convierta.',
      steps: [
        {
          title: 'Análisis Estratégico',
          description: 'Audito tu marca, tu audiencia y tu comunicación actual. Identifico los puntos de fricción que frenan tu crecimiento y definimos juntos los objetivos reales: posicionamiento, conversión o autoridad.',
          tags: ['Auditoría', 'Análisis de Audiencia', 'Definición de Objetivos'],
        },
        {
          title: 'Estrategia de Contenido',
          description: 'Diseño el sistema completo: pilares de contenido, narrativa de marca, guiones y estructura de publicación. Todo bajo los principios de valor, venta y branding.',
          tags: ['Concepto Creativo', 'Guión', 'Storyboard'],
        },
        {
          title: 'Producción & Dirección',
          description: 'Dirijo la grabación con criterio cinematográfico y estratégico. Cada toma está pensada para capturar exactamente lo que tu marca necesita comunicar.',
          tags: ['Dirección', 'Grabación', 'Coordinación'],
        },
        {
          title: 'Edición & Post-Producción',
          description: 'Aquí el material cobra vida: montaje dinámico, motion graphics, color grading y sound design. Todo optimizado para retener la atención en tu plataforma objetivo.',
          tags: ['Montaje', 'Motion Graphics', 'Sound Design', 'Color Grading'],
        },
        {
          title: 'Optimización & Entrega',
          description: 'Analizo el rendimiento, ajusto la estrategia y entrego métricas claras. El contenido evoluciona con tu marca — no se publica y se olvida.',
          tags: ['Optimización', 'Feedback', 'Estrategia de Lanzamiento'],
        },
      ],
    },
    testimonials: {
      badge: 'Testimonios',
      title: 'Lo que dicen de mi trabajo',
      description: 'Comentarios reales de audiencias y clientes satisfechos',
      audienceTitle: 'Impacto en la audiencia',
      clientTitle: 'Testimonios de clientes',
      audienceRole: 'Espectador',
    },
    skills: {
      badge: 'Habilidades',
      title: 'Habilidades para crear',
    },
    faq: {
      badge: 'FAQ',
      title: 'Preguntas frecuentes',
      description: 'Todo lo que necesitas saber antes de empezar',
      items: [
        {
          question: '¿Qué tipo de proyectos manejas?',
          answer: 'Trabajo en edición de video para YouTube, redes sociales, publicidad digital, VSLs (Video Sales Letters), contenido educativo y campañas de marketing digital completas. Desde videos cortos hasta producciones largas con estrategia integral.',
        },
        {
          question: '¿Participas solo en la edición o también en la estrategia?',
          answer: 'Ofrezco ambos servicios. Puedo trabajar únicamente en la edición si ya tienes tu estrategia definida, o puedo desarrollar la estrategia completa de contenido y marketing desde cero, incluyendo concepto, guión, edición y plan de distribución.',
        },
        {
          question: '¿Cómo desarrollas la estrategia de un proyecto?',
          answer: 'Primero hago un análisis profundo de tu marca, audiencia y competencia. Luego defino objetivos claros y KPIs. Desarrollo el concepto creativo, estructura narrativa y plan de contenido. Todo está pensado para generar resultados medibles.',
        },
        {
          question: '¿Cuánto tarda un proyecto?',
          answer: 'Depende de la complejidad. Videos cortos (1-3 min): 3-5 días. Videos de YouTube (8-15 min): 1-2 semanas. Proyectos complejos con estrategia completa: 2-4 semanas. Siempre cumplo con los plazos acordados.',
        },
        {
          question: '¿Cómo funciona el proceso de revisión?',
          answer: 'Utilizo plataformas profesionales donde puedes comentar directamente en el timeline del video. Esto hace el feedback súper preciso y rápido. Incluyo 2-3 rondas de revisión según el paquete contratado.',
        },
        {
          question: '¿Trabajas con clientes internacionales?',
          answer: 'Sí, trabajo con clientes de todo el mundo. La comunicación es principalmente por videollamadas y herramientas colaborativas. He trabajado con marcas en España, México, Colombia, Argentina, Estados Unidos y más países.',
        },
      ],
    },
    contact: {
      badge: 'Contacto',
      title: 'Trabajemos juntos.',
      description: 'Cuéntame sobre tu proyecto y descubramos cómo elevar tu contenido.',
      nameLabel: 'Nombre',
      namePlaceholder: 'Tu nombre completo',
      emailLabel: 'Email',
      emailPlaceholder: 'tu@email.com',
      typeLabel: '¿Qué tipo de vídeo necesitas?',
      durationLabel: 'Duración del video',
      visionLabel: 'Comparte tu visión',
      visionPlaceholder: 'Cuéntame sobre tu proyecto, objetivos y expectativas...',
      customPlaceholder: 'Describe qué tipo de proyecto necesitas...',
      submit: 'Enviar solicitud',
      guarantee: 'Respuesta garantizada en menos de 24h.',
      toastTitle: '¡Solicitud Enviada!',
      toastDescription: 'Te responderé en menos de 24 horas.',
      options: {
        vertical: 'Formato vertical para redes sociales',
        verticalPrice: 'Desde 75$ hasta 450$',
        duration30: '30 segundos',
        duration60: '60 segundos',
        duration180: '180 segundos (3 min)',
        youtube: 'YouTube',
        youtubePrice: 'Desde 450$ a 1000$',
        monthly: 'Contenido mensual',
        monthlyPrice: 'Desde 600$ (12 videos)',
        custom: 'Personalizado',
      },
    },
    footer: {
      tagline: 'Transformando contenido ordinario en experiencias visuales extraordinarias.',
      navTitle: 'Navegación',
      portfolio: 'Portfolio',
      testimonios: 'Testimonios',
      proceso: 'Proceso',
      faq: 'FAQ',
      contacto: 'Contacto',
      socialTitle: 'Redes Sociales',
      copyright: '© {year} Jhon Cesar. Todos los derechos reservados.',
      developedBy: 'Desarrollado por',
    },
  },
  en: {
    nav: {
      portfolio: 'Portfolio',
      proceso: 'Process',
      testimonios: 'Testimonials',
      contacto: 'Contact',
      hablemos: "Let's Talk",
      langLabel: 'EN',
    },
    hero: {
      titleLine1: 'STORIES THAT',
      titleHighlight: 'SELL.',
      subtitle: "I'm a filmmaker and content strategist. I produce, direct, and edit videos designed to position your brand, retain audiences, and turn followers into clients.",
      viewProjects: 'View Projects',
      contact: 'Contact',
      statVisits: 'Views Generated',
      statClients: 'Satisfied Clients',
      statRating: 'Client Rating',
      scrollCue: 'Scroll Down',
    },
    clients: {
      badge: 'They Trust Me',
      title: 'Brands I Have Transformed',
      description: 'I work with brands and creators who understand content as a strategic asset, not a daily obligation.',
      statVisits: 'Views generated',
      statClients: 'Satisfied clients',
      statRating: 'Average rating',
    },
    portfolio: {
      badge: 'Portfolio',
      title: 'Real videos & real results',
      viewYoutube: 'View all on YouTube',
      resultLabel: 'Result',
      category: 'Client',
      items: {
        joaquin_result: 'Featured projects',
        joaquin_summary: 'Reels & social media content',
        edt_result: 'Institutional campaigns',
        edt_summary: 'Optimized conversion reels',
        indawork_result: 'B2B content',
        indawork_summary: 'Positioning reels',
        luma_result: 'Premium production',
        luma_summary: 'Cinematic-quality reels',
        rolitornillos_result: 'Technical content',
        rolitornillos_summary: 'Demo & promotional reels',
        kukymotos_result: 'E-commerce campaigns',
        kukymotos_summary: 'Sales-oriented reels',
        otros_result: 'Reels collection',
        otros_summary: 'Additional projects',
        otros_title: 'Other Featured Projects',
      },
    },
    process: {
      badge: 'My Process',
      title: 'How I Work',
      description: 'Every project starts by understanding your brand from within to build a system that attracts, educates, and converts.',
      steps: [
        {
          title: 'Strategic Analysis',
          description: "I audit your brand, audience, and current communication. I identify friction points holding back your growth, and together we define real goals: positioning, conversion, or authority.",
          tags: ['Audit', 'Audience Analysis', 'Goal Setting'],
        },
        {
          title: 'Content Strategy',
          description: 'I design the complete system: content pillars, brand narrative, scripts, and publishing structure. Everything built on principles of value, sales, and branding.',
          tags: ['Creative Concept', 'Script', 'Storyboard'],
        },
        {
          title: 'Production & Direction',
          description: 'I direct the shoot with cinematographic and strategic criteria. Every shot is designed to capture exactly what your brand needs to communicate.',
          tags: ['Direction', 'Shooting', 'Coordination'],
        },
        {
          title: 'Editing & Post-Production',
          description: 'This is where the material comes to life: dynamic editing, motion graphics, color grading, and sound design. Everything optimized to retain attention on your target platform.',
          tags: ['Editing', 'Motion Graphics', 'Sound Design', 'Color Grading'],
        },
        {
          title: 'Optimization & Delivery',
          description: 'I analyze performance, adjust the strategy, and deliver clear metrics. Content evolves with your brand — it doesn\'t get published and forgotten.',
          tags: ['Optimization', 'Feedback', 'Launch Strategy'],
        },
      ],
    },
    testimonials: {
      badge: 'Testimonials',
      title: 'What they say about my work',
      description: 'Real feedback from audiences and satisfied clients',
      audienceTitle: 'Audience Impact',
      clientTitle: 'Client Testimonials',
      audienceRole: 'Viewer',
    },
    skills: {
      badge: 'Skills',
      title: 'Skills to Create',
    },
    faq: {
      badge: 'FAQ',
      title: 'Frequently Asked Questions',
      description: 'Everything you need to know before getting started',
      items: [
        {
          question: 'What types of projects do you handle?',
          answer: 'I work on video editing for YouTube, social media, digital advertising, VSLs (Video Sales Letters), educational content, and complete digital marketing campaigns. From short videos to long-form productions with comprehensive strategy.',
        },
        {
          question: 'Do you only do editing or also strategy?',
          answer: "I offer both services. I can work purely on editing if you already have your strategy defined, or I can develop the complete content and marketing strategy from scratch, including concept, script, editing, and distribution plan.",
        },
        {
          question: 'How do you develop a project strategy?',
          answer: "I start with a deep analysis of your brand, audience, and competition. Then I define clear goals and KPIs. I develop the creative concept, narrative structure, and content plan. Everything is designed to generate measurable results.",
        },
        {
          question: 'How long does a project take?',
          answer: "It depends on complexity. Short videos (1-3 min): 3-5 days. YouTube videos (8-15 min): 1-2 weeks. Complex projects with full strategy: 2-4 weeks. I always meet the agreed deadlines.",
        },
        {
          question: 'How does the revision process work?',
          answer: "I use professional platforms where you can comment directly on the video timeline. This makes feedback super precise and fast. I include 2-3 rounds of revision depending on the package hired.",
        },
        {
          question: 'Do you work with international clients?',
          answer: "Yes, I work with clients from all over the world. Communication is mainly through video calls and collaborative tools. I've worked with brands in Spain, Mexico, Colombia, Argentina, the United States, and more countries.",
        },
      ],
    },
    contact: {
      badge: 'Contact',
      title: "Let's work together.",
      description: 'Tell me about your project and let\'s discover how to elevate your content.',
      nameLabel: 'Name',
      namePlaceholder: 'Your full name',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      typeLabel: 'What type of video do you need?',
      durationLabel: 'Video duration',
      visionLabel: 'Share your vision',
      visionPlaceholder: 'Tell me about your project, goals, and expectations...',
      customPlaceholder: 'Describe what type of project you need...',
      submit: 'Send request',
      guarantee: 'Guaranteed response within 24h.',
      toastTitle: 'Request Sent!',
      toastDescription: 'I will respond within 24 hours.',
      options: {
        vertical: 'Vertical format for social media',
        verticalPrice: 'From $75 to $450',
        duration30: '30 seconds',
        duration60: '60 seconds',
        duration180: '180 seconds (3 min)',
        youtube: 'YouTube',
        youtubePrice: 'From $450 to $1000',
        monthly: 'Monthly content',
        monthlyPrice: 'From $600 (12 videos)',
        custom: 'Custom',
      },
    },
    footer: {
      tagline: 'Turning ordinary content into extraordinary visual experiences.',
      navTitle: 'Navigation',
      portfolio: 'Portfolio',
      testimonios: 'Testimonials',
      proceso: 'Process',
      faq: 'FAQ',
      contacto: 'Contact',
      socialTitle: 'Social Media',
      copyright: '© {year} Jhon Cesar. All rights reserved.',
      developedBy: 'Developed by',
    },
  },
};

export default translations;
